export class Version {
	sha1: string;
	version: string;

	constructor(sha1: string, version: string) {
		this.sha1 = sha1;
		this.version = version;
	}

	estPertinente(): boolean {
		return !!this.version && !!this.sha1;
	}

	versionDifferente(nouvelleVersion: Version) {
		return this.version !== nouvelleVersion.version || this.sha1 !== nouvelleVersion.sha1;
	}
}
